import React from "react"

import SEO from "../../../components/seo"
import Layout from "../../../components/layout"
import CustomNavTitle from "../../../components/CustomNavTitle"
import DefaultLayoutSidebar from "../../../components/DefaultLayoutSidebar"

import illustration2x from "../../../images/illustrations/illustration-requirements-granulocyte@2x.png"

import { theme } from "../../../styles/theme"

const IutNeonates = ({ location }) => {
  return (
    <Layout>
      <SEO title="Specific Requirements - Patients requiring granulocyte transfusion" />

      <CustomNavTitle
        title="Specific Requirements"
        destination="/requirements/cmv-negative-components/"
        location={location}
      />

      <DefaultLayoutSidebar>
        <section className="theme max-w-content">
          <h3 css={[theme.components.title, theme.components.titleRed]}>
            Patients requiring granulocyte transfusion
          </h3>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Indication for CMV negative components
          </h4>
          <p>
            For all CMV negative patients requiring granulocyte transfusion.
          </p>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Duration of requirement
          </h4>
          <p>At each episode.</p>
        </section>
        <aside>
          <img src={illustration2x} alt="Illustration" />
        </aside>
      </DefaultLayoutSidebar>
    </Layout>
  )
}

export default IutNeonates
